import { useEffect } from 'react';

import useScanQueueStore from '../../stores/scanQueueStore';
import { useRealtimeCallback } from '../../hooks/useRealtimeEvent';
import { REALTIME_EVENTS } from '../../services/realtime/RealtimeSyncService';

/** Safety-net refresh while the dashboard is open and the tab is visible (WS is per-instance). */
export const SCAN_QUEUE_POLL_MS = 20000;
const FRESH_MS = 5000;

let pollUsers = 0;
let pollTimer = null;
function startSharedPoll(load) {
  pollUsers += 1;
  if (pollUsers === 1) pollTimer = setInterval(() => { if (!document.hidden) load(); }, SCAN_QUEUE_POLL_MS);
  return () => {
    pollUsers -= 1;
    if (pollUsers === 0) { clearInterval(pollTimer); pollTimer = null; }
  };
}

/**
 * The ONE poller for the Scan & Share waiting list: one fetch on mount, one per WS event, one per
 * 20 s tick (paused while the tab is hidden, stopped on unmount). Renders nothing. Without
 * ABHA_SCAN_SHARE the queue API refuses (403), so the host panel mounts nothing at all. Mounted by
 * ScanShareQueuePanel and by the dashboard ABHA card (count pill) - one shared interval however many hosts mount.
 */
export default function ScanShareQueueSync() {
  const load = useScanQueueStore((s) => s.load);
  useEffect(() => {
    // A second mounted host (dashboard pill + a list, ABHA tab) must not double the traffic:
    // skip the mount fetch when the shared store is fresh, and share ONE interval across hosts.
    const { updatedAt } = useScanQueueStore.getState();
    if (!updatedAt || Date.now() - updatedAt > FRESH_MS) load();
    return startSharedPoll(load);
  }, [load]);
  useRealtimeCallback([REALTIME_EVENTS.ABHA_SCAN_SHARE, REALTIME_EVENTS.ABHA_SCAN_SHARE_CLAIMED], load);
  return null;
}
